import Button from "./Button";
import CapitalGainTaxHeading from "./Heading";
import Image from "./Image";
import Input from "./Input";
import Header from "./Header";
import NewHeader from "./NewHeader";
import NewFooter from "./NewFooter";
import Footer from "./Footer";
import AppBanner from "./AppBanner";
import CtaBanner from "./CtaBanner";
import Modal from "./Modal";
import Dot from "./Dot";
import Confirmation from "./Confirmation";
import Arrows from "./Arrows";
import DownArrow from "./DownArrow";
import Spinner from "./Spinner";
import Loading from "./Loading";
import TeamMemberCarousel from "./TeamMemberCarousel";
import ContactUs from "./ContactUs";
import {
  Heading,
  PrimaryText,
  SecondaryText
} from "./Text";

import Recommended from "./GreyMatter/Recommended";
import Insights from "./GreyMatter/Insights";
import Stories from "./GreyMatter/Stories";
import Newsletter from "./GreyMatter/Newsletter";
import SubscribeGreyMatter from "./GreyMatter/Subscribe";
import SubscribeConfirmation from "./GreyMatter/SubscribeConfirmation";

import InsightsThankYou from "./insights/ThankYou";
import InsightsShareFooter from "./insights/ShareFooter";
import InsightsBanner from "./insights/Banner";
import SegmentAnalytics from "./SegmentAnalytics";

import AppDownloadPopUp from "./PopUps/AppDownloadPopUp";
import SubscribeNewsletterPopUp from "./PopUps/SubscribeNewsletterPopUp";
import ScheduleMeetingPopUp from "./PopUps/ScheduleMeetingPopUp";

import BreadCrumbs from "./BreadCrumbs";
import AccordianFaq from "./AccordianFaq";
import Pagination from "./Pagination";

import {
  LatestBlogs,
  BannerCta
} from "./BlogDetail";
import ManageBlogFaqs from "./ManageBlogFaqs";
import DialogBox from "./DialogBox";

import {
  ProductSlider,
  BrokeragePricing,
  WhyWealthyBroking,
  BrokingFaqs,
  BrokingBannerCta,
  GetStartedCta,
  HeroBanner
} from "./BrokingLanding";

import {
  PricingBanner,
  RegulatoryCharges,
  DematCharges,
  GetStartedSection,
  PriceTable,
  OtherCharges,
  BrokerageCharges
} from "./Pricing";

export {
  Arrows,
  Button,
  CapitalGainTaxHeading,
  Dot,
  Image,
  Input,
  Header,
  NewHeader,
  NewFooter,
  Footer,
  AppBanner,
  CtaBanner,
  Modal,
  Confirmation,
  DownArrow,

  Heading,
  PrimaryText,
  SecondaryText,
  Spinner,
  Loading,
  TeamMemberCarousel,
  ContactUs,

  Recommended,
  Insights,
  Stories,
  Newsletter,
  SubscribeGreyMatter,
  SubscribeConfirmation,

  InsightsShareFooter,
  InsightsThankYou,
  InsightsBanner,

  SegmentAnalytics,

  AppDownloadPopUp,
  SubscribeNewsletterPopUp,
  ScheduleMeetingPopUp,

  BreadCrumbs,
  AccordianFaq,
  Pagination,
  LatestBlogs,
  BannerCta,
  ManageBlogFaqs,
  DialogBox,

  ProductSlider,
  BrokeragePricing,
  WhyWealthyBroking,
  BrokingFaqs,
  BrokingBannerCta,
  GetStartedCta,
  HeroBanner,

  PricingBanner,
  RegulatoryCharges,
  DematCharges,
  GetStartedSection,
  PriceTable,
  OtherCharges,
  BrokerageCharges
};
